<template>
  <section>
    <!-- Componentes externos -->
    <crear-actualizar-incremento-salarial />
    <VerRegistro />
    <AprobarIncrementoSalarial />
    <h3 class="primary--text">
      <v-icon color="primary">attach_money</v-icon> Incremento salarial por
      cargo
    </h3>
    <!-- Boton filtro -->
    <v-tooltip bottom>
      <v-btn
        @click.native="
          () => {
            filterShow = filterShow ? false : true;
          }
        "
        class="btn-refresh"
        slot="activator"
        ><v-icon>filter_list</v-icon>
      </v-btn>
      <span>Búsqueda/filtros</span>
    </v-tooltip>
    <!-- Boton actualizar -->
    <v-tooltip bottom>
      <v-btn
        @click.native="cargarIncrementoSalarial()"
        class="btn-refresh"
        slot="activator"
        ><v-icon>refresh</v-icon>
      </v-btn>
      <span>{{ $t("common.updateList") }}</span>
    </v-tooltip>
    <v-flex xs12>
      <transition name="slide-fade">
        <div class="filter-container" v-show="filterShow">
          <v-icon small color="primary">search</v-icon>

          <div class="filter-item">
            <v-text-field
              label="Gestión"
              v-model="form.gestion"
              @input="filterGestion(form.gestion)"
            ></v-text-field>
          </div>

          <div class="filter-item">
            <v-text-field
              label="Fecha creación"
              type="date"
              v-model="form.fecha_creacion"
              @input="filterFechaCreacion(form.fecha_creacion)"
            ></v-text-field>
          </div>

          <div class="filter-item">
            <v-text-field
              label="Fecha aprobación"
              type="date"
              v-model="form.fecha_aprobacion"
              @input="filterFechaAprobacion(form.fecha_aprobacion)"
            ></v-text-field>
          </div>

          <div class="filter-item">
            <v-text-field
              label="Fecha ejecución"
              v-model="form.fecha_ejecucion"
              type="date"
              @input="filterFechaEjecucion(form.fecha_ejecucion)"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Estado"
              v-model="form.estado"
              @input="filterEstado(form.estado)"
            ></v-text-field>
          </div>

          <!-- botones cerrar -->
          <div class="btn-filter">
            <v-tooltip bottom>
              <v-btn icon small slot="activator" @click.native="recargar()">
                <v-icon small>refresh</v-icon>
              </v-btn>
              <span>Recargar filtros</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-btn
                icon
                slot="activator"
                @click.native="
                  () => {
                    filterShow = false;
                    recargar();
                  }
                "
              >
                <v-icon>close</v-icon>
              </v-btn>
              <span>Cerrar filtros</span>
            </v-tooltip>
          </div>
        </div>
      </transition>
    </v-flex>
    <br />
    <v-tooltip bottom>
      <v-btn
        color="primary"
        dark
        @click.native.stop="crearActualizarIncrementoSalarial({})"
        slot="activator"
        ><v-icon dark>add</v-icon> {{ $t("common.add") }}</v-btn
      >
      <span>nuevo</span>
    </v-tooltip>
    <v-card>
      <v-card-text>
        <!-- <crud-table
					   :search="filters"
          :custom-filter="customFilter"
				> -->
        <v-data-table
          :headers="headers"
          :items="lista_incremento_salarial"
          class="elevation-1"
          :no-data-text="loading ? 'Cargando...' : 'No se tiene registros'"
          :disable-initial-sort="true"
          :loading="loading"
          no-results-text="No se encontraron coincidencias"
          item-key="index"
          :search="filters"
          :custom-filter="customFilter"
          :rows-per-page-items="[20, 40, { text: 'Todos', value: -1 }]"
        >
          <!-- Template injectable de la cabecera de la tabla -->
          <template slot="buttons">
            <v-tooltip bottom>
              <v-btn
                color="primary"
                dark
                @click.native.stop="crearActualizarIncrementoSalarial({})"
                slot="activator"
                ><v-icon dark>add</v-icon> {{ $t("common.add") }}</v-btn
              >
              <span>Agregar Incremento salarial</span>
            </v-tooltip>
          </template>

          <!-- Template de filas y columnas -->
          <template slot="items" slot-scope="items">
            <!-- Agregar las columnas que consideré necesarias -->
            <td class="text-xs-center">{{ items.item.gestion }}</td>
            <td class="text-xs-center">
              {{ $moment(items.item.fecha_creacion).format("DD-MM-YYYY") }}
            </td>
            <td class="text-xs-center">
              {{
                items.item.fecha_aprobacion
                  ? $moment(items.item.fecha_aprobacion).format("DD-MM-YYYY")
                  : ""
              }}
            </td>
            <td class="text-xs-center">
              {{ $moment(items.item.fecha_ejecucion).format("DD-MM-YYYY") }}
            </td>
            <td class="text-xs-center">{{ items.item.estado }}</td>
            <td class="nowrap text-xs-center">
              <v-tooltip bottom>
                <v-btn
                  v-if="items.item.id_estado == 22"
                  icon
                  color="rgb(87,51,204)"
                  dark
                  slot="activator"
                  @click.native="crearActualizarIncrementoSalarial(items.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>Editar registro</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn
                  v-if="items.item.id_estado == 22"
                  icon
                  color="rgb(217,38,38)"
                  dark
                  slot="activator"
                  @click.native="eliminarIncrementoCabeceraYDetalle(items.item)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
                <span>Eliminar registro</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn
                  icon
                  color="rgb(255,179,0)"
                
                  slot="activator"
                  @click.native="verRegistro(items.item)"
                >
                  <v-icon>visibility</v-icon>
                </v-btn>
                <span>Ver registro</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn
                  icon
                  v-if="items.item.id_estado == 22"
                  color="rgb(147,13,242)"
                  dark
                  slot="activator"
                  @click.native="aprobarIncrementoSalarial(items.item)"
                >
                  <v-icon>done</v-icon>
                </v-btn>
                <span>Aprobar</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import CrearActualizarIncrementoSalarial from "./dialogs/CrearActualizarIncrementoSalarial";
import VerRegistro from "./dialogs/VerRegistro";
import AprobarIncrementoSalarial from "./dialogs/AprobarIncrementoSalarial";
import Filtros from "./mixins/filtros";

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [crud, Filtros],
  // Variables iniciales del componente
  data() {
    return {
      url: "incrementoSalarials",
      graphql: true,
      lista_incremento_salarial: [],
      loading: false,
      form: {},
      // Variables filtros
      filters: {
        gestion: "",
        fecha_creacion: "",
        fecha_aprobacion: "",
        fecha_ejecucion: "",
        estado: "",
      },
      filterShow: true,
      // Cabecera de la tabla
      headers: [
        { text: "Gestión", value: "gestion", align: "center" },
        { text: "Fecha de creación", value: "fecha_creacion", align: "center" },
        {
          text: "Fecha de aprobación",
          value: "fecha_aprobacion",
          align: "center",
        },
        {
          text: "Fecha de ejecución",
          value: "fecha_ejecucion",
          align: "center",
        },
        { text: "Estado", value: "estado", align: "center" },
        { text: this.$t("common.actions"), sortable: false, align: "center" },
      ],
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
        id
        id_estado

        _user_created
        _user_updated
        _created_at
        _updated_at
      `,
      // Filtros del componente CrudTable ejemplo:
      // {
      // 	field: 'Campo definido en Graphql',
      // 	label: 'Etiqueta del input generado',
      // 	type: 'text', // Tipo de input en el filtro
      // 	typeG: 'String' // Tipo definido en Graphql
      // }
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    await this.cargarIncrementoSalarial();
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }

    this.$bus.$on("closeDialogIncrementoSalarial", async () => {
      await this.cargarIncrementoSalarial();
    });
    this.$bus.$on("closeDialogVerIncremento", async () => {});
    this.$bus.$on("closeDialogAprobarIncremento", async () => {
      await this.cargarIncrementoSalarial();
    });
  },
  // Métodos y funciones del componente
  methods: {
    crearActualizarIncrementoSalarial(item) {
      this.$bus.$emit("openDialogCrearActualizarIncrementoSalarial", item);
    },
    aprobarIncrementoSalarial(item) {
      this.$bus.$emit("openDialogAprobarIncremento", item);
    },
    verRegistro(item) {
      this.$bus.$emit("openDialogVerIncremento", item);
    },
    async eliminarIncrementoCabeceraYDetalle(dato) {
      try {
        this.$confirm("Desea eliminar el registro?", async () => {
          let usuario = this.$storage.get("user");
          let respuesta = await this.$service.graphql({
            query: `
                          query{
                            runQuery(consulta:"select movilidad.fn_elimina_incremento_salarial(${parseInt(
                              dato.id_incremento
                            )},${usuario.id})"){
                            respuesta
                            }
                          }
                        `,
          });
          respuesta =
            respuesta.runQuery.respuesta[0].fn_elimina_incremento_salarial;
          let resps = respuesta.split("|");
          if (resps[0] == "1") {
            //eliminando los detalles:
            let detalles = [];
            detalles = await this.cargarIncrementoSalarialDetalle(
              dato.id_incremento
            );
            console.log("++++", detalles);
            for (let j = 0; j < detalles.length; j++) {
              const elemento = detalles[j];
              let rpta = await this.$service.graphql({
                query: `
                          query{
                            runQuery(consulta:"select movilidad.fn_elimina_incremento_salarial_detalle(${parseInt(
                              elemento.id_incremento_salarial_detalle
                            )},${elemento.id_cargo},${usuario.id})"){
                            respuesta
                            }
                          }
                        `,
              });
            }
            this.$message.info("Registro eliminado exitosamente");
            await this.cargarIncrementoSalarial();
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    async cargarIncrementoSalarialDetalle(id) {
      try {
        let incremento_salarial_detalles = [];
        let respuesta = await this.$service.graphql({
          query: `
				query {
					runQuery(consulta:"select * from movilidad.v_incremento_salarial_detalle vis where vis.id_incremento_salarial=${parseInt(
            id
          )} and vis.id_estado_incremento_salarial_detalle<>2"){
						respuesta
					}
					}
				`,
        });
        if (respuesta.runQuery.respuesta.length > 0) {
          incremento_salarial_detalles = respuesta.runQuery.respuesta;
        }
        return incremento_salarial_detalles;
      } catch (error) {
        console.log(error);
      }
    },
    async cargarIncrementoSalarial() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
           query {
              runQuery(consulta:"select id_incremento, gestion, fecha_creacion, fecha_aprobacion, fecha_ejecucion, id_estado, estado from movilidad.v_incremento_salarial vip where vip.id_estado<>2"){
                respuesta
              }
            }
          `,
        });
        this.lista_incremento_salarial = respuesta.runQuery.respuesta;
      } catch (error) {
        console.log(error);
      }
    },
  },
  // Definición de componentes importados
  components: {
    CrudTable,
    CrearActualizarIncrementoSalarial,
    AprobarIncrementoSalarial,
    VerRegistro,
  },
};
</script>

<style lang="scss">
$filterBackground: #e1f5f0;
$filterBorder: #e5e5e5;
#cabecera_tabla {
  background: #007dbb;
  font-weight: bold;
  color: white;
}
.filter-container {
  background-color: $filterBackground;
  padding: 10px 15px 20px;
  border: 1px solid $filterBorder;
  position: relative;
  .filter-item {
    display: inline-block;
    margin-right: 15px;
    vertical-align: top;
    padding: 0em 0em 0em 0em;
    margin: 0em 0em 0em 0em;
    .v-text-field {
      padding: 0em 0em 0em 0em;
      margin: 0em 0em 0em 0em;
    }
  }
  & > .btn-filter {
    position: absolute;
    top: -8px;
    right: 0px;
  }
  & > .v-icon {
    display: inline-block;
    margin: 14px 5px 0 0;
  }
}
.style-1 {
  background-color: rgb(191, 255, 139);
}
#style-2 {
  background: #025a66e8;
  color: white;
}
#celda_especial {
  background: rgba(233, 252, 191, 0.822);
}
#celda_especial2 {
  background: rgba(202, 243, 243, 0.767);
}
#celda {
  background: rgba(158, 205, 241, 0.5);
}
#celda_roja {
  background: rgba(190, 9, 36, 0.3);
}
.filtrosActivoFijo {
  min-width: 100%;
  padding: 0em 0.5em 0em 0.5em;
}
.sinMargen {
  margin: 0em 0em 0em 0em;
  padding: 0em 0em 0em 0em;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/incremento_salarial/Index.vue